import CigTree from './src/index.vue'
import type { App } from 'vue'
import type { SFCWithInstall } from '@park-ui/utils'

CigTree.install = (app: App): void => {
  app.component(CigTree.name, CigTree)
}

const _CigTree = CigTree as SFCWithInstall<typeof CigTree>

export default CigTree
export const ElCigTree = _CigTree
